import { withInstall } from '@hd-front-end/utils'
import Image from './src/image.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElImage: SFCWithInstall<typeof Image> = withInstall(Image)
export default ElImage

export * from './src/image'
